import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20 px-4 md:px-10">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="常见问题"
            title="打不开、换地址、找不到，先看这里"
            desc="整理的都是大家问得最多的问题。如果没有覆盖到，可以在下方社区里留言，我们会一起看。"
          />

          <div className="mt-6 rounded-lg bg-secondary-100 border border-secondary-200 p-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-background-50 text-secondary-700 flex items-center justify-center">
                <i className="ri-question-answer-line text-xl" />
              </span>
              <p className="text-sm font-medium text-foreground-950">还没解决你的问题？</p>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              把具体情况发到社区板块，看到地址失效、线路异常的反馈，我们会尽快跟进并在更新动态里说明。
            </p>
            <a
              href="#community"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-secondary-800 hover:text-secondary-900 cursor-pointer whitespace-nowrap"
            >
              去社区留言
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border transition-colors ${
                  isOpen ? "bg-background-100 border-primary-300" : "bg-background-100 border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen ? (
                  <p className="px-5 pb-5 -mt-1 text-sm leading-relaxed text-foreground-600 animate-fade-in">
                    {item.a}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}